module.exports = ".w100 {\n  width: 100% !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assgin-messages/assgin-messages.component.scss
// module id = ./src/app/admin/assgin-messages/assgin-messages.component.scss
// module chunks = main